import { BillsActions, EBillsActions } from '../actions/bills.actions';
import { BillInterfaceState, initialBillState } from '../state/bill.state';

export function billReducer(state: BillInterfaceState = initialBillState, action: BillsActions): BillInterfaceState {
  switch (action.type) {
    case EBillsActions.SetSelectedBill: {
      return { ...state, bill: action.payload };
    }

    default:
      return state;
  }
};
